import Tag from '@assets/icons/tag.svg'
import { Icon } from './Icon'

export const TagIcon = Icon(Tag)
